import React from "react";
import PageShell from "@/components/PageShell";
import { FileText } from "lucide-react";

const Terms = () => {
  return (
    <PageShell navyTheme={true}>
      <section className="relative">
        <div className="mx-auto max-w-4xl px-4 py-8 md:py-14">
          <div className="text-xs uppercase tracking-[0.2em] text-[#22C585] font-semibold">
            Legal
          </div>
          <h1
            className="mt-2 text-4xl md:text-5xl font-extrabold text-white leading-tight"
            style={{ fontFamily: "Sora, Inter, sans-serif" }}
            data-testid="terms-title"
          >
            Terms of Service
          </h1>
          <p className="mt-3 text-[#C7D0DF]">
            Last updated:{" "}
            {new Date().toLocaleDateString(undefined, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          <article
            className="sn-glass-strong-dark rounded-3xl p-6 md:p-10 mt-8 sn-prose-dark"
            data-testid="terms-content"
          >
            <div
              className="mb-6 rounded-2xl p-5 flex items-start gap-3"
              style={{
                background:
                  "linear-gradient(120deg, rgba(34,197,133,0.14) 0%, rgba(34,197,133,0.04) 100%)",
                border: "1px solid rgba(34,197,133,0.35)",
              }}
            >
              <FileText className="text-[#22C585] mt-0.5" size={20} />
              <div className="text-sm text-white">
                <div className="font-semibold">Placeholder terms</div>
                <p className="text-[#C7D0DF] mt-1 mb-0">
                  Our final Terms of Service are being finalized. The content below is
                  a placeholder and will be updated with the official document soon.
                </p>
              </div>
            </div>

            <h2>1. Introduction</h2>
            <p>
              Welcome to SpendNova™. By joining our waitlist or otherwise using our
              services, you agree to the terms outlined here. This document is a
              placeholder and does not constitute the final Terms of Service.
            </p>

            <h2>2. Eligibility</h2>
            <p>
              SpendNova is designed for everyone—including students, single parents,
              professionals, and military families. If you manage money, SpendNova is
              for you. You must simply be legally able to enter into a binding
              agreement to use our services.
            </p>

            <h2>3. Waitlist Communications</h2>
            <p>
              By submitting your email to our waitlist, you consent to receive
              product-related updates from SpendNova. You can unsubscribe at any time.
            </p>

            <h2>4. Acceptable Use</h2>
            <p>
              You agree not to misuse the SpendNova service, attempt to disrupt its
              operation, or use it to violate any law or regulation.
            </p>

            <h2>5. Changes to These Terms</h2>
            <p>
              We may update these terms as SpendNova evolves. When we do, we'll update
              the "Last updated" date above and notify waitlist members if the changes
              are material.
            </p>

            <h2>6. Contact</h2>
            <p>
              Questions? Reach us at{" "}
              <a href="mailto:privacy@myspendnova.com">privacy@myspendnova.com</a>.
            </p>
          </article>
        </div>
      </section>
    </PageShell>
  );
};

export default Terms;
